/* =========================================================
   Meowdow theme — storefront JavaScript (vanilla, no deps)
   ========================================================= */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || T.moneyFormat || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, dec, ts = ',', ds = '.') => {
      const fixed = (n / 100).toFixed(dec);
      const [i, d] = fixed.split('.');
      const ii = i.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts);
      return d ? ii + ds + d : ii;
    };
    const m = format.match(re);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }
  T.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3500);
  }

  /* ---------- Body scroll lock ---------- */
  let locks = 0;
  const lock = () => { locks++; document.body.classList.add('no-scroll'); };
  const unlock = () => { locks = Math.max(0, locks - 1); if (!locks) document.body.classList.remove('no-scroll'); };

  /* ---------- Drawers (cart + mobile menu) ---------- */
  let lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lock();
    const focusable = $('[data-drawer-close]', drawer) || drawer;
    setTimeout(() => focusable.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlock();
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.drawerOpen);
      if (d) { e.preventDefault(); openDrawer(d); if (opener.dataset.drawerOpen === 'CartDrawer') Cart.refresh(); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      Lightbox.close();
    }
    // simple focus trap inside open drawer
    if (e.key === 'Tab') {
      const d = $('.drawer.is-open .drawer__panel');
      if (!d) return;
      const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', d).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header: sticky + height var ---------- */
  function initHeader() {
    const stack = $('[data-header-stack]');
    if (!stack) return;
    const header = $('.site-header', stack);
    const sticky = header && header.dataset.sticky;
    stack.classList.toggle('is-sticky', sticky === 'always' || sticky === 'smart');
    const setH = () => document.documentElement.style.setProperty('--header-h', (sticky && sticky !== 'none' ? stack.offsetHeight : 0) + 'px');
    setH();
    window.addEventListener('resize', setH, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(stack);
    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      stack.classList.toggle('is-scrolled', y > 10);
      if (sticky === 'smart') {
        const hide = y > lastY && y > 300 && !document.body.classList.contains('no-scroll');
        stack.classList.toggle('is-hidden', hide);
      }
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Announcement rotator ---------- */
  function initRotators(root = document) {
    $$('[data-rotator]', root).forEach((r) => {
      if (r._init) return; r._init = true;
      const slides = $$('.announce__slide', r);
      if (slides.length < 2) return;
      let i = 0;
      const speed = (parseInt(r.dataset.speed, 10) || 5) * 1000;
      setInterval(() => {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  let revealObs;
  function initReveal(root = document) {
    const els = $$('.reveal:not(.is-in)', root);
    if (!document.body.classList.contains('anim-reveal') || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    revealObs = revealObs || new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); revealObs.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach((el) => revealObs.observe(el));
  }

  /* ---------- Accordion ---------- */
  document.addEventListener('click', (e) => {
    const q = e.target.closest('.accordion__q');
    if (!q) return;
    const open = q.getAttribute('aria-expanded') === 'true';
    const acc = q.closest('.accordion');
    if (acc && acc.dataset.single === 'true' && !open) {
      $$('.accordion__q[aria-expanded="true"]', acc).forEach((o) => { o.setAttribute('aria-expanded', 'false'); const it = o.closest('.accordion__item'); it && it.classList.remove('is-open'); });
    }
    q.setAttribute('aria-expanded', String(!open));
    const item = q.closest('.accordion__item');
    if (item) item.classList.toggle('is-open', !open);
  });

  /* ---------- Feature tabs ---------- */
  function initTabs(root = document) {
    $$('[data-ftabs]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const tabs = $$('[role="tab"]', wrap);
      const panes = $$('.ftabs__pane', wrap);
      const mText = $('[data-ftabs-mobile]', wrap);
      const select = (i, focus) => {
        tabs.forEach((t, j) => { t.setAttribute('aria-selected', String(i === j)); t.tabIndex = i === j ? 0 : -1; });
        panes.forEach((p, j) => { p.classList.toggle('is-active', i === j); p.setAttribute('aria-hidden', String(i !== j)); });
        if (mText && tabs[i]) {
          mText.innerHTML = '<h3>' + (tabs[i].dataset.title || '') + '</h3><p>' + (tabs[i].dataset.text || '') + '</p>';
        }
        if (focus) tabs[i].focus();
        const v = panes[i] && $('video', panes[i]);
        if (v && v.paused && v.autoplay) v.play().catch(() => {});
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(i));
        t.addEventListener('keydown', (e) => {
          const dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (dir) { e.preventDefault(); select((i + dir + tabs.length) % tabs.length, true); }
        });
      });
      wrap._select = select;
      if (wrap.dataset.autoplay && !reduceMotion) {
        let cur = 0, timer;
        const run = () => { timer = setInterval(() => { cur = (tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true') + 1) % tabs.length; select(cur); }, parseInt(wrap.dataset.autoplay, 10) * 1000); };
        run();
        wrap.addEventListener('pointerenter', () => clearInterval(timer));
        wrap.addEventListener('focusin', () => clearInterval(timer));
      }
    });
  }

  /* ---------- Lightbox ---------- */
  const Lightbox = {
    el: null, items: [], i: 0,
    init() {
      this.el = $('[data-lightbox]');
      if (!this.el) return;
      this.stage = $('[data-lb-stage]', this.el);
      this.count = $('[data-lb-count]', this.el);
      $('[data-lb-close]', this.el).addEventListener('click', () => this.close());
      $('[data-lb-prev]', this.el).addEventListener('click', () => this.go(this.i - 1));
      $('[data-lb-next]', this.el).addEventListener('click', () => this.go(this.i + 1));
      this.el.addEventListener('click', (e) => { if (e.target === this.stage) this.close(); });
      document.addEventListener('keydown', (e) => {
        if (!this.el.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft') this.go(this.i - 1);
        if (e.key === 'ArrowRight') this.go(this.i + 1);
      });
      let sx = null;
      this.stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      this.stage.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) this.go(this.i + (dx < 0 ? 1 : -1));
        sx = null;
      });
    },
    open(items, i = 0) {
      if (!this.el || !items.length) return;
      this.items = items; this.lastFocus = document.activeElement;
      this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false');
      lock(); this.go(i);
      $('[data-lb-close]', this.el).focus();
    },
    go(i) {
      const n = this.items.length;
      this.i = (i + n) % n;
      const it = this.items[this.i];
      this.stage.innerHTML = '';
      if (it.type === 'video') {
        const v = document.createElement('video');
        v.src = it.src; v.controls = true; v.autoplay = true; v.playsInline = true;
        this.stage.appendChild(v);
      } else {
        const img = new Image();
        img.src = it.src; img.alt = it.alt || '';
        this.stage.appendChild(img);
      }
      this.count.textContent = (this.i + 1) + ' / ' + n;
      $$('.lightbox__prev, .lightbox__next', this.el).forEach((b) => { b.hidden = n < 2; });
    },
    close() {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true');
      this.stage.innerHTML = ''; unlock();
      if (this.lastFocus) this.lastFocus.focus({ preventScroll: true });
    }
  };
  const bestSrc = (img) => {
    if (!img) return '';
    const set = img.getAttribute('srcset');
    if (set) { const parts = set.split(',').map((s) => s.trim().split(' ')[0]); return parts[parts.length - 1]; }
    return img.currentSrc || img.src;
  };

  // Generic media-grid lightbox groups
  document.addEventListener('click', (e) => {
    const item = e.target.closest('[data-lb-item]');
    if (!item) return;
    const group = item.closest('[data-lb-group]');
    if (!group) return;
    e.preventDefault();
    const nodes = $$('[data-lb-item]', group);
    const items = nodes.map((n) => n.dataset.video ? { type: 'video', src: n.dataset.video } : { type: 'image', src: n.dataset.full || bestSrc($('img', n)), alt: ($('img', n) || {}).alt });
    Lightbox.open(items, nodes.indexOf(item));
  });

  /* ---------- Gallery ---------- */
  class Gallery {
    constructor(el) {
      this.el = el;
      this.track = $('[data-gallery-track]', el);
      this.slides = $$('.gallery__slide', el);
      this.thumbs = $$('[data-thumb]', el);
      this.dots = $$('.gallery__dots span', el);
      this.prev = $('[data-gallery-prev]', el);
      this.next = $('[data-gallery-next]', el);
      this.index = 0;
      if (!this.track) return;
      this.prev && this.prev.addEventListener('click', () => this.go(this.index - 1));
      this.next && this.next.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(parseInt(t.dataset.thumb, 10))));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      });
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.setActive(i);
        });
      }, { passive: true });
      $$('[data-zoom]', el).forEach((b) => b.addEventListener('click', () => this.zoom(parseInt(b.dataset.zoom, 10))));
      const start = $('[data-start-media]', el);
      if (start) this.goToMedia(start.dataset.startMedia, true);
      this.setActive(this.index);
    }
    go(i, instant) {
      const n = this.slides.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      const left = this.slides[i].offsetLeft;
      if (instant || reduceMotion) this.track.scrollTo({ left, behavior: 'auto' });
      else this.track.scrollTo({ left, behavior: 'smooth' });
      this.setActive(i);
    }
    setActive(i) {
      this.index = i;
      this.thumbs.forEach((t, j) => { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      this.dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
      const th = this.thumbs[i];
      if (th && th.parentElement) {
        const p = th.parentElement;
        const vertical = p.scrollHeight > p.clientHeight + 4 && getComputedStyle(p).flexDirection === 'column';
        if (vertical) p.scrollTo({ top: th.offsetTop - p.clientHeight / 2 + th.clientHeight / 2, behavior: 'smooth' });
        else p.scrollTo({ left: th.offsetLeft - p.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
      }
      // pause videos in non-active slides
      this.slides.forEach((s, j) => { if (j !== i) $$('video', s).forEach((v) => v.pause()); });
    }
    goToMedia(id, instant) {
      if (!id || id === '0') return;
      const idx = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (idx > -1) this.go(idx, instant);
    }
    zoom(i) {
      const items = this.slides.map((s) => {
        const img = $('img', s);
        return img ? { type: 'image', src: bestSrc(img), alt: img.alt } : null;
      }).filter(Boolean);
      const imgSlides = this.slides.filter((s) => $('img', s) && !$('video, iframe', s));
      const target = imgSlides.indexOf(this.slides[i]);
      Lightbox.open(items, Math.max(0, target));
    }
  }

  /* ---------- Cart ---------- */
  const Cart = {
    sectionId: 'cart-drawer',
    drawer() { return document.getElementById('CartDrawer'); },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) {
        const msg = data.description || data.message || (T.strings && T.strings.error) || 'Something went wrong';
        throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
      }
      return data;
    },
    render(sections) {
      const html = sections && sections[this.sectionId];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-panel]');
      const cur = $('[data-cart-panel]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      const count = doc.querySelector('[data-cart-count-src]');
      if (count) this.setCount(parseInt(count.dataset.cartCountSrc, 10));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; });
    },
    async add(items, opts = {}) {
      const data = await this.request(T.routes.cartAdd + '.js', { items, sections: [this.sectionId], sections_url: window.location.pathname });
      if (opts.buyNow) { window.location.href = T.routes.checkout; return data; }
      if (T.cartType === 'checkout') { window.location.href = T.routes.checkout; return data; }
      if (T.cartType === 'page') { window.location.href = T.routes.cart; return data; }
      this.render(data.sections);
      openDrawer(this.drawer());
      if (opts.expected) this.verify(opts.expected);
      return data;
    },
    async change(line, quantity) {
      const d = this.drawer();
      d && d.classList.add('is-busy');
      try {
        const data = await this.request(T.routes.cartChange + '.js', { line, quantity, sections: [this.sectionId], sections_url: window.location.pathname });
        this.render(data.sections);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      } catch (err) { toast(err.message); }
      finally { d && d.classList.remove('is-busy'); }
    },
    async refresh() {
      try {
        const res = await fetch(window.location.pathname + '?sections=' + this.sectionId);
        if (res.ok) this.render(await res.json());
      } catch (e) { /* offline */ }
    },
    // Developer aid: warns (console + editor toast) if Shopify's real price differs from the displayed bundle price.
    async verify(expected) {
      try {
        const cart = await (await fetch(T.routes.cart + '.js')).json();
        const actual = cart.items.filter((it) => it.product_id === expected.productId && !(it.properties && it.properties._gift))
          .reduce((sum, it) => sum + it.final_line_price, 0);
        if (Math.abs(actual - expected.total) > expected.qty * 2 && (expected.pct > 0 || expected.amt > 0)) {
          const msg = 'Bundle price shown (' + formatMoney(expected.total) + ') differs from Shopify cart price (' + formatMoney(actual) + '). Create a matching automatic discount in Admin › Discounts.';
          console.warn('[Meowdow] ' + msg);
          if (window.Shopify && window.Shopify.designMode) toast(msg);
        }
      } catch (e) { /* ignore */ }
    }
  };
  T.cart = Cart;

  // Drawer + cart page interactions (delegated)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-qty]');
    if (btn) {
      e.preventDefault();
      const line = parseInt(btn.dataset.line, 10);
      const cur = parseInt(btn.dataset.current, 10);
      const delta = parseInt(btn.dataset.lineQty, 10);
      Cart.change(line, Math.max(0, cur + delta));
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(parseInt(rm.dataset.lineRemove, 10), 0); }
  });
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-line-input]');
    if (inp) Cart.change(parseInt(inp.dataset.lineInput, 10), Math.max(0, parseInt(inp.value, 10) || 0));
    const note = e.target.closest('[data-cart-note]');
    if (note) Cart.request(T.routes.cartUpdate + '.js', { note: note.value }).catch(() => {});
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) Cart.refresh(); });

  /* ---------- Product (variant picker, bundles, form) ---------- */
  class ProductRoot {
    constructor(el) {
      this.el = el;
      const json = $('[data-product-json]', el);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = $('[data-product-form]', el);
      this.idInput = $('[data-variant-id]', el);
      this.qtyInput = $('[data-qty-input]', el);
      this.atc = $('[data-atc]', el);
      this.buyNow = $('[data-buy-now]', el);
      this.err = $('[data-form-error]', el);
      this.bundles = $('[data-bundles]', el);
      this.galleryEl = $('[data-gallery]', el);
      this.gallery = this.galleryEl ? (this.galleryEl._gallery || (this.galleryEl._gallery = new Gallery(this.galleryEl))) : null;
      const startId = this.idInput ? parseInt(this.idInput.value, 10) : null;
      this.variant = this.product.variants.find((v) => v.id === startId) || this.product.variants[0];

      $$('[data-option-index]', el).forEach((inp) => inp.addEventListener('change', () => this.onOptionChange()));
      if (this.bundles) {
        $$('[data-bundle] input[type="radio"]', this.bundles).forEach((r) => r.addEventListener('change', () => this.selectBundle(r.closest('[data-bundle]'))));
        $$('[data-b-row]', this.bundles).forEach((s) => s.addEventListener('change', () => { s.dataset.touched = '1'; this.emit(); }));
      }
      const minus = $('[data-qty-minus]', el), plus = $('[data-qty-plus]', el);
      minus && minus.addEventListener('click', () => { this.qtyInput.value = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) - 1); this.emit(); });
      plus && plus.addEventListener('click', () => { this.qtyInput.value = Math.min(99, (parseInt(this.qtyInput.value, 10) || 1) + 1); this.emit(); });
      this.qtyInput && this.qtyInput.addEventListener('change', () => this.emit());
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(false); });
      this.buyNow && this.buyNow.addEventListener('click', () => this.submit(true));
      this.markAvailability();
      this.updatePrices();
      this.emit();
      el._product = this;
    }
    selectedOptions() {
      const opts = [];
      $$('[data-option-index]', this.el).forEach((inp) => {
        const i = parseInt(inp.dataset.optionIndex, 10);
        if (inp.type === 'radio') { if (inp.checked) opts[i] = inp.value; }
        else opts[i] = inp.value;
      });
      return opts;
    }
    onOptionChange() {
      const opts = this.selectedOptions();
      const v = this.product.variants.find((x) => x.options.every((o, i) => opts[i] === undefined || o === opts[i]));
      $$('[data-option-label]', this.el).forEach((l) => { const i = parseInt(l.dataset.optionLabel, 10); if (opts[i]) l.textContent = opts[i].charAt(0).toUpperCase() + opts[i].slice(1); });
      this.variant = v || null;
      if (v) {
        this.idInput.value = v.id;
        if (this.el.dataset.updateUrl !== 'false' && document.body.classList.contains('template-product')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (this.gallery && v.media_id) this.gallery.goToMedia(v.media_id);
        // Sync untouched bundle rows to the newly selected variant
        if (this.bundles) $$('[data-b-row]', this.bundles).forEach((s) => { if (!s.dataset.touched) s.value = String(v.id); });
      }
      this.markAvailability();
      this.updatePrices();
      this.emit();
    }
    markAvailability() {
      const opts = this.selectedOptions();
      $$('input[type="radio"][data-option-index]', this.el).forEach((inp) => {
        const i = parseInt(inp.dataset.optionIndex, 10);
        const test = opts.slice(); test[i] = inp.value;
        const ok = this.product.variants.some((v) => v.available && v.options.every((o, j) => test[j] === undefined || o === test[j]));
        inp.classList.toggle('is-unavailable', !ok);
      });
    }
    currentBundle() {
      if (!this.bundles) return null;
      const sel = $('[data-bundle].is-selected', this.bundles) || $('[data-bundle]', this.bundles);
      return sel || null;
    }
    selectBundle(card) {
      $$('[data-bundle]', this.bundles).forEach((c) => c.classList.toggle('is-selected', c === card));
      this.updatePrices();
      this.emit();
    }
    unitPrice() { return this.variant ? this.variant.price : 0; }
    // Calculates the displayed total. Mixed-colour rows use each row's own variant price.
    calc() {
      const b = this.currentBundle();
      const v = this.variant;
      if (!v) return { total: 0, qty: 1, pct: 0, regular: 0 };
      if (!b) {
        const q = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
        return { total: v.price * q, qty: q, pct: 0, regular: (v.compare_at_price > v.price ? v.compare_at_price : v.price) * q };
      }
      const q = parseInt(b.dataset.qty, 10) || 1;
      const pct = parseFloat(b.dataset.pct) || 0;
      const amt = parseInt(b.dataset.amt, 10) || 0;
      const rows = $$('[data-b-row]', b);
      let line = 0, regular = 0;
      if (rows.length) {
        rows.forEach((r) => {
          const rv = this.product.variants.find((x) => String(x.id) === r.value) || v;
          line += rv.price; regular += rv.compare_at_price > rv.price ? rv.compare_at_price : rv.price;
        });
      } else {
        line = v.price * q; regular = (v.compare_at_price > v.price ? v.compare_at_price : v.price) * q;
      }
      const total = Math.max(0, line - Math.round(line * pct / 100) - amt);
      return { total, qty: q, pct, amt, regular, line };
    }
    updatePrices() {
      const v = this.variant;
      const priceWrap = $('[data-price]', this.el);
      if (v && priceWrap) {
        $('[data-price-now]', priceWrap).textContent = formatMoney(v.price);
        const was = $('[data-price-was]', priceWrap), save = $('[data-price-save]', priceWrap);
        const onSale = v.compare_at_price > v.price;
        if (was) { was.hidden = !onSale; was.textContent = onSale ? formatMoney(v.compare_at_price) : ''; }
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = (save.dataset.tpl || 'Save __P__%').replace('__P__', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price));
        }
      }
      // Bundle cards
      if (this.bundles && v) {
        $$('[data-bundle]', this.bundles).forEach((card) => {
          const q = parseInt(card.dataset.qty, 10) || 1;
          const pct = parseFloat(card.dataset.pct) || 0;
          const amt = parseInt(card.dataset.amt, 10) || 0;
          let line = 0, regular = 0;
          const rows = $$('[data-b-row]', card);
          if (rows.length && card.classList.contains('is-selected')) {
            rows.forEach((r) => { const rv = this.product.variants.find((x) => String(x.id) === r.value) || v; line += rv.price; regular += rv.compare_at_price > rv.price ? rv.compare_at_price : rv.price; });
          } else { line = v.price * q; regular = (v.compare_at_price > v.price ? v.compare_at_price : v.price) * q; }
          const total = Math.max(0, line - Math.round(line * pct / 100) - amt);
          const saved = regular - total;
          const set = (sel, txt, hide) => { const n = $(sel, card); if (n) { if (txt !== null) n.textContent = txt; if (hide !== undefined) n.hidden = hide; } };
          set('[data-b-total]', formatMoney(total));
          set('[data-b-compare]', formatMoney(regular), saved <= 0);
          const each = $('[data-b-each]', card);
          if (each) each.textContent = each.dataset.tpl.replace('__P__', formatMoney(Math.floor(total / q)));
          const sv = $('[data-b-save]', card);
          if (sv) { sv.hidden = saved <= 0; sv.textContent = sv.dataset.tpl.replace('__P__', formatMoney(saved)); }
        });
      }
      // Buttons
      const available = !!(v && v.available);
      const c = this.calc();
      if (this.atc) {
        this.atc.disabled = !available;
        const t = $('[data-atc-text]', this.atc);
        if (t) t.textContent = !v ? (T.strings.unavailable) : (available ? this.atc.dataset.label : T.strings.soldOut);
        const p = $('[data-atc-price]', this.atc);
        if (p) p.textContent = formatMoney(c.total);
      }
      if (this.buyNow) this.buyNow.disabled = !available;
      const stock = $('[data-stock]', this.el);
      if (stock) { stock.textContent = available ? stock.dataset.in : stock.dataset.out; stock.classList.toggle('is-out', !available); }
    }
    emit() {
      const c = this.calc();
      const v = this.variant;
      const b = this.currentBundle();
      const titleBits = [];
      if (v && v.title && v.title !== 'Default Title') titleBits.push(this.labelFor(v));
      if (b && c.qty > 1) titleBits.push('× ' + c.qty);
      else if (!b && c.qty > 1) titleBits.push('× ' + c.qty);
      this.el.dispatchEvent(new CustomEvent('product:change', {
        bubbles: true,
        detail: { product: this.product, variant: v, total: c.total, qty: c.qty, label: titleBits.join(' '), image: (v && v.image) || this.product.featured_image, available: !!(v && v.available) }
      }));
    }
    labelFor(v) {
      // Only include options that have more than one value
      const multi = this.product.options.map((_, i) => new Set(this.product.variants.map((x) => x.options[i])).size > 1);
      const parts = v.options.filter((_, i) => multi[i]);
      return (parts.length ? parts : v.options).map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(' / ');
    }
    buildItems() {
      const v = this.variant;
      if (!v) return [];
      const b = this.currentBundle();
      const counts = new Map();
      if (b) {
        const rows = $$('[data-b-row]', b);
        if (rows.length) rows.forEach((r) => counts.set(r.value, (counts.get(r.value) || 0) + 1));
        else counts.set(String(v.id), parseInt(b.dataset.qty, 10) || 1);
      } else {
        counts.set(String(v.id), this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1);
      }
      const items = Array.from(counts, ([id, quantity]) => ({ id: parseInt(id, 10), quantity }));
      if (b && b.dataset.gift) items.push({ id: parseInt(b.dataset.gift, 10), quantity: 1, properties: { _gift: 'bundle' } });
      return items;
    }
    async submit(buyNow) {
      const items = this.buildItems();
      if (!items.length) return;
      const btn = buyNow ? this.buyNow : this.atc;
      if (this.err) this.err.hidden = true;
      btn && btn.classList.add('is-loading');
      btn && btn.setAttribute('aria-busy', 'true');
      const c = this.calc();
      try {
        await Cart.add(items, { buyNow, expected: { productId: this.product.id, total: c.total, qty: c.qty, pct: c.pct, amt: c.amt } });
      } catch (err) {
        if (this.err) { this.err.textContent = err.message; this.err.hidden = false; }
        else toast(err.message);
      } finally {
        btn && btn.classList.remove('is-loading');
        btn && btn.removeAttribute('aria-busy');
      }
    }
  }
  T.ProductRoot = ProductRoot;

  /* ---------- Sticky add-to-cart ---------- */
  function initStickyAtc() {
    const bar = $('[data-sticky-atc]');
    if (!bar || bar._init) return;
    bar._init = true;
    const root = $('[data-product-root]');
    document.body.classList.add('has-sticky-atc');
    if (bar.classList.contains('sticky-atc--mobile-only')) document.body.classList.add('sticky-mobile-only');
    const btn = $('[data-sticky-btn]', bar);
    const price = $('[data-sticky-price]', bar);
    const meta = $('[data-sticky-meta]', bar);
    const img = $('[data-sticky-img]', bar);
    document.addEventListener('product:change', (e) => {
      if (root && e.target !== root) return;
      const d = e.detail;
      if (price) price.textContent = formatMoney(d.total);
      if (meta) meta.textContent = d.label || '';
      if (img && d.image) img.src = d.image;
      if (btn) btn.disabled = !d.available;
    });
    if (root && root._product) root._product.emit();
    btn && btn.addEventListener('click', () => {
      const p = root && root._product;
      if (p) p.submit(false);
      else if (btn.dataset.href) window.location.href = btn.dataset.href;
    });
    // Visibility: show once the main buy button has scrolled out of view, hide near footer
    const target = (root && $('[data-atc]', root)) || $('[data-sticky-anchor]');
    const footer = $('.site-footer');
    let pastAtc = false, footerVisible = false;
    const update = () => bar.classList.toggle('is-visible', pastAtc && !footerVisible && !document.body.classList.contains('no-scroll'));
    if ('IntersectionObserver' in window) {
      if (target) new IntersectionObserver(([en]) => { pastAtc = !en.isIntersecting && en.boundingClientRect.top < 0; update(); }).observe(target);
      else { pastAtc = true; }
      if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; update(); }).observe(footer);
    }
    update();
  }

  /* ---------- Tracking form ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-tracking-form]');
    if (!f) return;
    e.preventDefault();
    const num = ($('input[name="tracking"]', f).value || '').trim();
    if (!num) return;
    const pattern = f.dataset.pattern || 'https://www.17track.net/en/track?nums={number}';
    window.open(pattern.replace('{number}', encodeURIComponent(num)), '_blank', 'noopener');
  });

  /* ---------- Init ---------- */
  function initAll(root = document) {
    initRotators(root);
    initReveal(root);
    initTabs(root);
    $$('[data-gallery]', root).forEach((g) => { if (!g._gallery && !g.closest('[data-product-root]')) g._gallery = new Gallery(g); });
    $$('[data-product-root]', root).forEach((p) => { if (!p._product) new ProductRoot(p); });
    initStickyAtc();
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    Lightbox.init();
    initAll();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => { initAll(e.target); if (e.target.querySelector('[data-header-stack], .site-header')) initHeader(); });
  document.addEventListener('shopify:block:select', (e) => {
    const tab = e.target.closest('[role="tab"]');
    const wrap = e.target.closest('[data-ftabs]');
    if (tab && wrap && wrap._select) wrap._select($$('[role="tab"]', wrap).indexOf(tab));
    const item = e.target.closest('.accordion__item');
    if (item) { const q = $('.accordion__q', item); q && q.setAttribute('aria-expanded', 'true'); item.classList.add('is-open'); }
    $$('.reveal', e.target).forEach((r) => r.classList.add('is-in'));
  });
})();
